import type { Organization } from '../../../../types/organization.types';

type OnboardingIdx = NonNullable<Organization['onboardingData']>['idx'];

/**
 * True when the org's IDX data came from the original IDX setup (an IDX
 * subdomain or MLS entries) before onboarding asked for an IDX path. Orgs that
 * chose "Create Remi's IDX for me" use the same setup but aren't legacy.
 */
export const hasLegacyIdxData = (idx: OnboardingIdx | undefined): boolean => {
  if (idx?.idx_path) return false;
  const siteData = idx?.site_data as { idx_subdomain?: unknown } | undefined;
  const mlsEntries = idx?.mls_entries;
  return Boolean(siteData?.idx_subdomain) || (Array.isArray(mlsEntries) && mlsEntries.length > 0);
};

/**
 * True when the org uses a third-party IDX provider (their own IDX, not one
 * Speculo created), so Speculo's IDX Site settings don't apply to it.
 */
export const usesThirdPartyIdx = (idx: OnboardingIdx | undefined): boolean => {
  if (idx?.idx_path) return idx.idx_path === 'own';
  return Boolean(idx?.idx_display_url) && !hasLegacyIdxData(idx);
};
